import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { ComponentPropsWithoutRef } from "react";

import { VoiceMessageModalComponent } from "./VoiceMessageModalComponent";

const CompassModal = ModalManager.create(
  (
    props: Omit<
      ComponentPropsWithoutRef<typeof VoiceMessageModalComponent>,
      "open" | "onOpenChange"
    >,
  ) => {
    const modal = useModal();

    return (
      <VoiceMessageModalComponent
        {...props}
        open={modal.visible}
        onOpenChange={open => {
          if (!open) {
            modal.remove();
          }
        }}
      />
    );
  },
);

export const useVoiceMessageModal = () => useModal(CompassModal);
